import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

function Spinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-sambiva-cream">
      <Loader2 className="animate-spin text-sambiva-red" size={40} />
    </div>
  );
}

export function ProtectedRoute({ children, role, redirect }) {
  const { user, checked } = useAuth();
  if (!checked || user === null) return <Spinner />;
  if (!user) return <Navigate to={redirect} replace />;
  if (role && user.role !== role) return <Navigate to={redirect} replace />;
  return children;
}
